import { useScrollReveal } from "@/hooks/useScrollReveal";
import { socialLinks, email } from "@/data/contact";
import { Github, Linkedin, Mail } from "lucide-react";

const iconMap: Record<string, typeof Github> = {
  github: Github,
  linkedin: Linkedin,
  email: Mail,
};

export function Contact() {
  const headerRef = useScrollReveal<HTMLDivElement>({ y: 30 });
  const contentRef = useScrollReveal<HTMLDivElement>({ y: 20, delay: 0.2 });

  return (
    <section id="contact" className="min-h-[60vh] px-6 py-24">
      <div className="max-w-3xl mx-auto">
        <div ref={headerRef} className="mb-12">
          <div data-reveal className="flex items-center gap-3 mb-2">
            <span className="text-terminal-green">$</span>
            <span className="text-terminal-cyan">echo</span>
            <span className="text-foreground">"Let's connect"</span>
          </div>
          <h2 data-reveal className="text-2xl font-bold text-terminal-bright">
            Contact
          </h2>
        </div>

        <div
          ref={contentRef}
          className="border border-border rounded-lg p-6 bg-card"
        >
          <p data-reveal className="text-muted-foreground mb-6 leading-relaxed">
            I'm always open to interesting conversations, collaborations, or
            just talking about technology. Feel free to reach out through any of
            the channels below.
          </p>

          <div data-reveal className="space-y-3">
            {Object.entries(socialLinks).map(([platform, { url, label }]) => {
              const Icon = iconMap[platform] || Mail;
              return (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-secondary transition-colors group"
                >
                  <Icon
                    size={18}
                    className="text-muted-foreground group-hover:text-terminal-green transition-colors"
                  />
                  <div>
                    <div className="text-sm font-medium text-foreground group-hover:text-terminal-green transition-colors">
                      {label}
                    </div>
                    <div className="text-xs text-muted-foreground">{url}</div>
                  </div>
                </a>
              );
            })}
          </div>

          <div data-reveal className="mt-8 pt-4 border-t border-border text-sm">
            <span className="text-terminal-green">$</span>
            <span className="text-terminal-cyan ml-2">echo</span>
            <span className="text-foreground ml-2">{email}</span>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 text-center text-xs text-terminal-dim">
          <p>Built with React, TypeScript, Tailwind CSS & GSAP</p>
          <p className="mt-1">
            <span className="text-terminal-green">$</span>
            <span className="ml-2">© {new Date().getFullYear()} Khang</span>
          </p>
        </div>
      </div>
    </section>
  );
}
